const toggleMenu = (dispatch, changeState) => {
  dispatch(changeState());
};

export { toggleMenu };
